module.exports = __webpack_public_path__ + "static/img/componyIcon.a86beeed.jpg";